import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)', color: 'white', padding: '4rem 0 2rem', borderTop: '3px solid #6d28d9'}}>
      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 2rem'}}>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', marginBottom: '3rem'}}>
          <div>
            <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem', fontFamily: 'Space Grotesk', fontSize: '1.5rem', fontWeight: '700'}}>
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="8" fill="#6d28d9"/>
                <path d="M12 12h10c3 0 5 2 5 4.5c0 1.5-0.8 2.8-2 3.5c1.5 0.5 2.5 2 2.5 3.5c0 2.5-2 4.5-5 4.5h-6v-7l5-1c1 0 2-0.5 2-1.5s-1-1.5-2-1.5h-9.5v-4z" fill="#ffffff"/>
                <circle cx="28" cy="28" r="3" fill="#f59e0b"/>
              </svg>
              <span style={{color: '#ffffff'}}>RMQ Digital</span>
            </div>
            <p style={{color: 'rgba(255,255,255,0.7)', lineHeight: '1.8', marginBottom: '1rem'}}>
              B2B software platform providing secure customer communication tools for verified businesses.
            </p>
            <p style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.5)', marginBottom: '0.5rem'}}>
              <strong>Legal Entity:</strong> RMQ HOLDINGS INC
            </p>
            <p style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.4)', fontStyle: 'italic'}}>
              Business Communication Platform
            </p>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#8b5cf6'}}>Platform</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Services</Link>
              <Link to="/how-it-works" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>How It Works</Link>
              <Link to="/platform-requirements" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Platform Requirements</Link>
              <Link to="/pricing" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Pricing</Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#8b5cf6'}}>Legal</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <Link to="/privacy" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Privacy Policy</Link>
              <Link to="/terms" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Terms of Service</Link>
              <Link to="/sms-terms" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>SMS Terms</Link>
              <Link to="/compliance" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Compliance</Link>
              <Link to="/verification" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Verification</Link>
              <Link to="/opt-out" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'color 0.3s'}}>Opt-Out</Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#8b5cf6'}}>Contact</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', color: 'rgba(255,255,255,0.7)'}}>
              <p><strong style={{color: 'rgba(255,255,255,0.9)'}}>RMQ HOLDINGS INC</strong></p>
              <p>2022 EAST 9TH STREET<br />BROOKLYN, NY 11223<br />United States</p>
              <p>EIN: 99-1828959</p>
              <p>DUNS: 129201132</p>
              <p>Owner: MOSHE QUBRUSI</p>
              <p style={{marginTop: '0.5rem'}}>info@rmqdigital.com</p>
              <p>support@rmqdigital.com</p>
            </div>
          </div>
        </div>
        
        <div style={{paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center'}}>
          <p style={{color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem'}}>
            © {new Date().getFullYear()} RMQ HOLDINGS INC (DBA: RMQ Digital). All rights reserved. | Business Communication Platform
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
